module.exports = __webpack_public_path__ + "static/media/Multilingual_popup.3822e0e7.png";